import React from 'react';
import {connect} from 'react-redux';

import {getIndices} from 'topmeteo/general/selectors';
import {changeImage} from 'topmeteo/base-image/actionCreators';

import Column from './Column';

const Columns = ({columns, indices, onClick}) => columns.map(column => {
    const {start} = column;
    const {current} = indices[start];

    return (
        <Column
            {...column}
            key={start}
            index={start}
            current={current}
            onClick={onClick}
        />
    );
});

const mapStateToProps = state => {
    const indices = getIndices(state);

    return {
        indices,
    };
};

const mapDispatchToProps = (dispatch, {productID}) => ({
    onClick: index => dispatch(changeImage({productID, index})),
});

export default connect(mapStateToProps, mapDispatchToProps)(Columns);
